// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ConnectS3ToSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  config: Types.S3ConnectionInput;
}>;


export type ConnectS3ToSiteMutation = (
  { __typename?: 'Mutation' }
  & { connectS3ToSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);


export const ConnectS3ToSiteDocument = gql`
    mutation ConnectS3ToSite($siteId: UUID!, $config: S3ConnectionInput!) {
  connectS3ToSite(siteId: $siteId, config: $config) {
    success
    message
    errorType
  }
}
    `;
export type ConnectS3ToSiteMutationFn = ApolloReactCommon.MutationFunction<ConnectS3ToSiteMutation, ConnectS3ToSiteMutationVariables>;

/**
 * __useConnectS3ToSiteMutation__
 *
 * To run a mutation, you first call `useConnectS3ToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectS3ToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectS3ToSiteMutation, { data, loading, error }] = useConnectS3ToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useConnectS3ToSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectS3ToSiteMutation, ConnectS3ToSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<ConnectS3ToSiteMutation, ConnectS3ToSiteMutationVariables>(ConnectS3ToSiteDocument, baseOptions);
      }
export type ConnectS3ToSiteMutationHookResult = ReturnType<typeof useConnectS3ToSiteMutation>;
export type ConnectS3ToSiteMutationResult = ApolloReactCommon.MutationResult<ConnectS3ToSiteMutation>;
export type ConnectS3ToSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectS3ToSiteMutation, ConnectS3ToSiteMutationVariables>;
